// src/i18n/en/reservations.ts
// English mirror of es/reservations.ts.
export const reservations = {
  name: 'Reservations',

  filters: {
    button: 'Filters',
    hotel: 'Hotel',
    axis: 'Date axis',
    axisArrival: 'Arrival',
    axisActivity: 'Activity',
    from: 'From',
    to: 'To',
    state: 'State',
    channelUsed: 'Channel',
    preCheckIn: 'Pre-check-in',
    preCheckInDone: 'Done',
    preCheckInPartial: 'Partial',
    preCheckInNone: 'Not started',
    payment: 'Payment',
    paymentPaid: 'Paid',
    paymentFailed: 'Failed',
    paymentNone: 'No payment',
    key: 'Key',
    keyCard: 'Card',
    keyDigital: 'Digital key',
    keyNone: 'No key',
    kioskLeftMidway: 'Left midway at the kiosk',
    needsHelp: 'Needs help',
    isWalkIn: 'Walk-in',
    origin: 'Origin',
    search: 'Search by guest or reservation number',
    apply: 'Apply',
    clear: 'Clear filters',
  },

  activeFilters: {
    axis: 'Axis: %{value}',
    from: 'From %{value}',
    to: 'To %{value}',
    state: 'State: %{value}',
    channelUsed: 'Channel: %{value}',
    preCheckIn: 'Pre-check-in: %{value}',
    payment: 'Payment: %{value}',
    key: 'Key: %{value}',
    kioskLeftMidway: 'Left midway',
    needsHelp: 'Needs help',
    isWalkIn: 'Walk-in',
    origin: 'Origin: %{value}',
    search: 'Search: %{value}',
  },

  columns: {
    arrival: 'Arrival',
    departure: 'Departure',
    guest: 'Guest',
    room: 'Room',
    hotel: 'Hotel',
    preCheckIn: 'Pre-check-in',
    checkIn: 'Check-in',
    key: 'Key',
    charged: 'Charged',
    state: 'State',
  },

  checkIn: {
    reception: 'Reception',
    none: '—',
  },

  summary: {
    count: '%{count} reservation |||| %{count} reservations',
    checkedIn: 'Checked in %{count}',
    preCheckInDone: 'Pre-check-in done %{count}',
    charged: 'Charged %{amount}',
  },

  emptyState: {
    title: 'No reservations match these filters',
    description: 'Try widening the date range or removing a filter.',
  },

  detail: {
    title: 'Reservation detail',
    reservationNumber: 'Reservation %{number}',
    adults: '%{count} adult |||| %{count} adults',
    children: '%{count} child |||| %{count} children',
    origin: 'Origin: %{origin}',
    arrivalDeparture: 'Arrival %{arrival} · Departure %{departure}',
    room: 'Room %{room}',
    walkIn: 'Walk-in',

    facts: {
      preCheckIn: 'Pre-check-in',
      identification: 'Identification',
      payment: 'Payment',
      checkIn: 'Check-in',
      key: 'Key',
      stay: 'Stay',
      nights: '%{count} night |||| %{count} nights',
      night: '1 night',
    },

    timeline: {
      title: "The guest's path",
      empty: 'No activity recorded yet for this reservation.',
      attemptsPreCheckIn: '%{smart_count} pre-check-in attempt |||| %{smart_count} pre-check-in attempts',
      attemptsKiosk: '%{smart_count} kiosk attempt |||| %{smart_count} kiosk attempts',
      technicalLink: 'View technical detail',
      kinds: {
        linkOpened: 'Opened the pre-check-in link',
        started: 'Started pre-check-in',
        stopped: 'Stopped at %{section}',
        resumed: 'Resumed',
        preCheckInDone: 'Pre-check-in done · %{identified} of %{total} identified',
        checkInStarted: 'Started check-in',
        checkInDone: 'Check-in done · %{duration}',
        paymentDone: 'Charged %{amount} with %{method}',
        paymentFailed: 'Could not continue at Payment',
        keyDelivered: 'Key delivered · %{keyType} · room %{room}',
        keyFailed: 'Key could not be delivered',
      },
    },
  },

  export: {
    page: 'reservations',
    reservationNumber: 'Reservation number',
    room: 'Room',
    identification: 'Identified',
    payment: 'Payment',
    preCheckInDoneAt: 'Pre-check-in done on',
    currency: 'Currency',
  },

  help: {
    title: 'Reservations',
    description: 'The full reservation list, filterable by date, channel, pre-check-in state, payment and key.',
    features: {
      urlFilters: 'Filters are stored in the address bar: you can share a filtered view.',
      rowClick: 'Every row opens the full reservation record.',
      summary: 'The summary is computed over the filtered set, not just the visible page.',
      charged:
        '«Charged» follows the Payments rule: firm charges minus refunds of the filtered reservations, on every channel, without pre-authorisations and one figure per currency. It shows «—» when a paid reservation has no detail of its transactions. The «Charged» column of each row applies the same rule to that reservation; «—» when nothing was charged or the detail is missing.',
    },
    tips: {
      search: 'Use search to find a reservation by guest or number.',
      export: 'Export the filtered view to CSV with the "Export" button.',
    },
  },
};

export default reservations;
